import React from 'react';
type FooterColumn = {
  heading: string;
  links: string[];
};
const columns: FooterColumn[] = [{
  heading: 'For Patients',
  links: ['Find a Pharmacy', 'Map View', 'Compare Pharmacies', 'Online Pharmacies', 'Read Reviews', 'Write a Review', 'Drug Shortages']
}, {
  heading: 'For Pharmacies',
  links: ['Why PharmacyPulse', 'Claim Your Listing', 'Owner Dashboard', 'Review Widget', 'Pricing', 'How It Works']
}, {
  heading: 'Account',
  links: ['Sign Up', 'Log In', 'My Account', 'My Home Feed', 'Forgot Password']
}, {
  heading: 'Company',
  links: ['About PharmacyPulse', 'Privacy Policy', 'Terms of Service', 'Security Contact']
}];
const disclosure = 'PharmacyPulse provides pharmacy listings, community reviews, and drug-availability information for general informational purposes only. It is not medical advice and is not a substitute for guidance from a licensed pharmacist or healthcare provider. Pharmacy and shortage data is sourced from the NPPES/NPI registry, the FDA, and community contributions, and may be incomplete, outdated, or inaccurate. PharmacyPulse is not affiliated with, and does not endorse, the pharmacies listed. Always confirm hours, services, and medication availability directly with the pharmacy before relying on this information.';
export function MasterFooter() {
  return <footer className="w-full border-t border-white/10 bg-[#0F1117] text-white" data-id="element-108" data-mp="3eycr9waanjvy">
      <section className="border-b border-white/10" data-id="element-109" data-mp="39xp11ctw372s">
        <div className="w-full px-6 py-10 md:px-12 lg:px-16" data-id="element-110" data-mp="39wdpgqu7cv14">
          <h2 className="text-2xl font-black tracking-tight text-white" data-id="element-111" data-mp="34y3r67d6leba">
            PharmacyPulse
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-6 text-gray-400" data-id="element-112" data-mp="1yjuoh5ua6hrt">
            Built for patients. Trusted by pharmacies. Community-powered reviews
            that help your neighbors find care they can count on.
          </p>
        </div>
      </section>
      <section className="border-b border-white/10" data-id="element-113" data-mp="pmms0wm68vbr">
        <div className="grid w-full gap-8 px-6 py-10 sm:grid-cols-2 lg:grid-cols-4 md:px-12 lg:px-16" data-id="element-114" data-mp="plbngukwjjjl">
          {columns.map(column => <div key={column.heading} data-id="element-115" data-mp="gl6jyvitx5ap">
              <h3 className="text-sm font-bold text-white" data-id="element-116" data-mp="gjvd2mu37hfd">{column.heading}</h3>
              <ul className="mt-4 space-y-2.5" data-id="element-117" data-mp="1vhdckryw931">
                {column.links.map(link => <li key={link} data-id="element-118" data-mp="6niog3deftrh">
                    <a href="#" className="text-sm text-gray-400 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-119" data-mp="6ojyq5mlcc85">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </section>
      <section className="border-b border-white/10 bg-white/5" data-id="element-120" data-mp="3k1ne0qq7bbpp">
        <div className="w-full px-6 py-6 text-[11px] leading-5 text-gray-500 md:px-12 lg:px-16" data-id="element-121" data-mp="30flgr93ji71y">
          {disclosure}
        </div>
      </section>
      <section data-id="element-122" data-mp="2wguszskys1ri">
        <div className="flex w-full flex-col gap-3 px-6 py-5 text-xs text-gray-500 sm:flex-row sm:items-center sm:justify-between md:px-12 lg:px-16" data-id="element-123" data-mp="3aejdgzb4d6w1">
          <p data-id="element-124" data-mp="35eoncxz64lc1">© 2026 PharmacyPulse · Built with ♥ for health equity</p>
          <div className="flex gap-5 font-bold" data-id="element-125" data-mp="3jeplw6ryngoc">
            <a href="#" className="hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-126" data-mp="3jdel8fttap1g">
              Privacy
            </a>
            <a href="#" className="hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-127" data-mp="3t754n6b309aa">
              Terms
            </a>
            <a href="#" className="hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-128" data-mp="6vq5d2141a99">
              Security
            </a>
          </div>
        </div>
      </section>
    </footer>;
}